import React from 'react';
import { ExternalLinkIcon, LockIcon, ShieldIcon, DropletIcon } from 'lucide-react';
import type { Device } from '../../../types/db';
const ICONS = {
  slot: LockIcon,
  alarm: ShieldIcon,
  watersensor: DropletIcon
} as const;
const HA_URL = 'http://homeassistant.local:8123/lovelace/beveiliging';

/** Locks and alarm: read-only. Anna never operates these — you do, in the app of the device. */
export function SecurityStatus({
  devices
}: {
  devices: Device[];
}) {
  return <div className="rounded-3xl border border-white/[0.07] bg-night-900 p-6" data-id="element-307" data-mp="1o7hugn1fpof2">
      <ul className="divide-y divide-white/[0.06]" data-id="element-308" data-mp="1o5euba6kiewm">
        {devices.map(d => {
        const Icon = ICONS[d.kind as keyof typeof ICONS] ?? ShieldIcon;
        const operable = d.kind === 'slot' || d.kind === 'alarm';
        const warn = d.status === 'nat' || d.status === 'open' || d.status === 'afgegaan';
        return <li key={d.id} className="flex items-center gap-4 py-3.5 first:pt-0 last:pb-0" data-id="element-309" data-mp="15hiagekgazii">
              <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-white/[0.05] text-ink-soft" data-id="element-310" data-mp="16dxtr0e97wql">
                <Icon className="h-4 w-4" strokeWidth={1.75} aria-hidden data-id="element-311" data-mp="1bbz8j94nd9w9" />
              </span>
              <div className="min-w-0 flex-1" data-id="element-312" data-mp="1g38vg1yt9z4g">
                <p className="text-[15px] text-ink" data-id="element-313" data-mp="1g5lnj7ya9pv8">{d.name}</p>
                <p className={`text-[13px] ${warn ? 'text-amber' : 'text-ink-muted'}`} data-id="element-314" data-mp="1k41711v5og3w">{d.status}</p>
              </div>
              {operable && <a href={HA_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-white/10 px-3 py-1.5 text-[13px] font-medium text-ink-soft transition-colors duration-150 hover:border-white/20 hover:text-ink" data-id="element-315" data-mp="nh67qj7bv3iu">
                  Bedien zelf <ExternalLinkIcon className="h-3.5 w-3.5" aria-hidden data-id="element-316" data-mp="27wrfv27rij9y" />
                </a>}
            </li>;
      })}
      </ul>
      <p className="mt-5 flex items-start gap-2 border-t border-white/[0.06] pt-4 text-[13px] leading-relaxed text-ink-muted" data-id="element-317" data-mp="cqh19m4koz0x">
        <LockIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden data-id="element-318" data-mp="8pnc6pfe9e6g" />
        Sloten en alarm staan op niveau Nooit. Anna toont de status, maar bedienen doe je zelf in Home Assistant of de app
        van het apparaat.
      </p>
    </div>;
}